class GameConfig {
  public loadedPath: string | undefined;
  public config: ConfigParams = {} as ConfigParams;

  private static instance: GameConfig;

  private constructor() {}

  public static getInstance(): GameConfig {
    if (!GameConfig.instance) {
      GameConfig.instance = new GameConfig();
    }

    return GameConfig.instance;
  }

  async load(path: string): Promise<ConfigParams> {
    console.log(`Loading config from path: ${path}`);

    await fetch(path)
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        return response.json();
      })
      .then((data) => {
        this.config = data;
        this.loadedPath = path;
      });

    console.log("Config loaded data: ", this.config);

    return this.config;
  }

  public loadConfig(data: any): ConfigParams {
    this.config = data;

    return this.config;
  }
}

export enum ColumnAlignment {
  LEFT = "left",
  RIGHT = "right",
}

export type CurrentJackpotDefinition = {
  id: number;
  x: number;
  y: number;
  size: number;
  color: string;
  spin_duration: number;
  delay_show: number;
  max_height: number;
  max_width: number;
};

export type InfoMessagesDefinition = {
  x: number;
  y: number;
  width: number;
  height: number;
  size: number;
  color: string;
  type: "scroll" | "cycle";
  cycle_interval: number;
  scroll_delimeter?: string;
  scroll_margin: number;
  scroll_speed: number;
  messages: string[];
};

export type ConfigParams = {
  app: {
    websocket_address: string;
    sign_id: string;
    jackpot_id: number | null;
    screenWidth: number;
    screenHeight: number;
  };
  localization: {
    locale: string;
    language: string;
    languagePath: string;
  };
  display?: {
    showMachineIdOnHitScreen?: boolean;
    showDateOnHitScreen?: boolean;
    showTimeOnHitScreen?: boolean;
    showMachineIdInHistory?: boolean;
    // showJackpotNameInHistory?: boolean;
    showTimeInHistory?: boolean;
    currencySymbol?: string;
    showDecimals?: boolean;
  };
  timings?: {
    jackpotHitScreenDurationSeconds?: number;
    currentJackpotScreenDurationSeconds?: number;
    historyScreenDurationSeconds?: number;
  };
};

export default GameConfig;
